import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useLojas } from "@/hooks/useLojas";
import { CatalogPicker, precoCat } from "./CatalogPicker";

export const ESTILOS_ARMACAO = [
  "Clássico Feminino", "Clássico Masculino", "Metal Feminino",
  "Metal Masculino", "Clip on Feminino", "Clip on Masculino",
];
export const ESTILOS_OCULOS = ["Óculos Masculino", "Óculos Feminino"];

const BASE_NOMES = ["Lente Visão Simples", "Lente Multifocal", "Armação", "Óculos de Sol", "Acessórios", "Serviços"];

export default function ReceitaBasicInfo({
  register, setValue, initialData, dataVenda, setDataVenda, tipoProduto, onTipoProdutoChange, catalogo = [], loja, estiloArmacao,
}) {
  const lojas = useLojas();
  const ORIGENS_VENDA = ["Tráfego", "Influencer", "Indicação", "Recompra", "Outros"];
  const [origemSel, setOrigemSel] = React.useState(initialData?.origem_cliente || "");
  const lensNames = ["Lente Visão Simples", "Lente Multifocal", ...catalogo.filter((c) => c.eh_lente).map((c) => c.nome)];
  const extrasProduto = catalogo.filter((c) => !BASE_NOMES.includes(c.nome));
  const ehLente = lensNames.includes(tipoProduto);
  const mostrarCampoReferencia = ["Armação", "Óculos de Sol"].includes(tipoProduto);
  const mostrarCampoServico = tipoProduto === "Serviços";
  const mostrarCampoAcessorio = tipoProduto === "Acessórios";
  const estiloOpcoes = tipoProduto === "Armação" ? ESTILOS_ARMACAO : (tipoProduto === "Óculos de Sol" ? ESTILOS_OCULOS : null);
  const mostrarValorProduto = !!tipoProduto && !ehLente;

  return (
    <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="space-y-2">
          <Label htmlFor="data_venda" className="text-sm font-medium text-slate-700">Data da Venda</Label>
          <Input
            id="data_venda"
            type="date"
            value={dataVenda}
            onChange={(e) => setDataVenda(e.target.value)}
            className="bg-white"
            data-testid="input-data-venda"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="os" className="text-sm font-medium text-slate-700">Ordem de Servico (OS)</Label>
          <Input id="os" {...register("os")} placeholder="Numero da OS" data-testid="input-os" className="bg-white" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="nome_loja" className="text-sm font-medium text-slate-700">Nome da Loja</Label>
          <Select onValueChange={(value) => setValue("nome_loja", value)} defaultValue={initialData?.nome_loja}>
            <SelectTrigger className="bg-white" data-testid="select-nome-loja"><SelectValue placeholder="Selecione a loja" /></SelectTrigger>
            <SelectContent>
              {lojas.map((l) => (<SelectItem key={l} value={l}>{l}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="tipo_produto" className="text-sm font-medium text-slate-700">Tipo de Produto</Label>
          <Select value={tipoProduto} onValueChange={onTipoProdutoChange}>
            <SelectTrigger className="bg-white" data-testid="select-tipo-produto"><SelectValue placeholder="Selecione" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="Lente Visão Simples">Lente Visao Simples</SelectItem>
              <SelectItem value="Lente Multifocal">Lente Multifocal</SelectItem>
              <SelectItem value="Armação">Armacao</SelectItem>
              <SelectItem value="Óculos de Sol">Oculos de Sol</SelectItem>
              <SelectItem value="Acessórios">Acessorios</SelectItem>
              <SelectItem value="Serviços">Servicos</SelectItem>
              {extrasProduto.map((c) => (<SelectItem key={c.nome} value={c.nome}>{c.nome}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-2">
        <input
          type="checkbox"
          id="incluir_relatorio_lentes"
          {...register("incluir_relatorio_lentes")}
          defaultChecked={initialData?.incluir_relatorio_lentes !== false}
          className="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
          data-testid="checkbox-incluir-relatorio"
        />
        <Label htmlFor="incluir_relatorio_lentes" className="text-sm text-slate-600">
          Incluir no Relatorio de Lentes
        </Label>
        <span className="text-xs text-slate-400">(Desmarque para vendas sem lentes)</span>
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="space-y-2">
          <Label className="text-sm font-medium text-slate-700">Origem do Cliente</Label>
          <Select value={origemSel} onValueChange={(v) => { setOrigemSel(v); setValue("origem_cliente", v); }}>
            <SelectTrigger className="bg-white" data-testid="select-origem-cliente"><SelectValue placeholder="Selecione a origem" /></SelectTrigger>
            <SelectContent>
              {ORIGENS_VENDA.map((o) => (<SelectItem key={o} value={o}>{o}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        {(origemSel === "Outros" || origemSel === "Influencer") && (
          <div className="space-y-2">
            <Label htmlFor="origem_detalhe" className="text-sm font-medium text-slate-700">{origemSel === "Influencer" ? "Nome da Influencer" : "Qual origem?"}</Label>
            <Input id="origem_detalhe" {...register("origem_detalhe")} placeholder={origemSel === "Influencer" ? "Nome da influencer" : "Descreva a origem"} className="bg-white" data-testid="input-origem-detalhe" />
          </div>
        )}
        <div className="space-y-2">
          <Label htmlFor="desconto" className="text-sm font-medium text-slate-700">Total de Desconto na Compra (R$)</Label>
          <Input id="desconto" type="number" step="0.01" {...register("desconto")} placeholder="0.00" className="bg-white" data-testid="input-desconto" />
          <p className="text-xs text-slate-400">Valor total de desconto concedido</p>
        </div>
      </div>

      {mostrarCampoReferencia && (
        <div className="mt-4 space-y-2">
          <Label htmlFor="referencia" className="text-sm font-medium text-slate-700">Referência / Código da Armação</Label>
          <Input id="referencia" {...register("referencia")} placeholder="Ex: RB3025, OA-1234" className="bg-white max-w-md" data-testid="input-referencia" />
          <p className="text-xs text-slate-400">Código ou referência da armação/óculos</p>
          <CatalogPicker loja={loja} index="principal" onSelect={(prod) => {
            setValue("referencia", prod.codigo || prod.nome);
            setValue("valor_lente", precoCat(prod));
            setValue("catalogo_produto_id", prod.id);
            if (estiloOpcoes?.includes(prod.categoria)) setValue("estilo_armacao", prod.categoria);
          }} />
        </div>
      )}

      {mostrarCampoServico && (
        <div className="mt-4 space-y-2">
          <Label htmlFor="descricao_servico" className="text-sm font-medium text-slate-700">Descrição do Serviço</Label>
          <Input id="descricao_servico" {...register("descricao_servico")} placeholder="Ex: Ajuste de armação, Troca de parafuso, Limpeza" className="bg-white" data-testid="input-descricao-servico" />
          <p className="text-xs text-slate-400">Descreva o serviço realizado</p>
        </div>
      )}

      {estiloOpcoes && (
        <div className="mt-4 space-y-2">
          <Label className="text-sm font-medium text-slate-700">Estilo da Armação</Label>
          <Select key={tipoProduto} value={estiloArmacao || ""} onValueChange={(value) => setValue("estilo_armacao", value)}>
            <SelectTrigger className="bg-white max-w-md" data-testid="select-estilo-armacao"><SelectValue placeholder="Selecione o estilo" /></SelectTrigger>
            <SelectContent>
              {estiloOpcoes.map((op) => (<SelectItem key={op} value={op}>{op}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
      )}

      {mostrarValorProduto && (
        <div className="mt-4 space-y-2">
          <Label htmlFor="valor_produto" className="text-sm font-medium text-slate-700">Valor do Produto (R$)</Label>
          <Input id="valor_produto" type="number" step="0.01" {...register("valor_lente")} placeholder="0.00" className="bg-white max-w-md" data-testid="input-valor-produto" />
          <p className="text-xs text-slate-400">Valor do produto principal desta venda</p>
        </div>
      )}
    </div>
  );
}
